import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

type PathNavigatorProps = {
  path: string;
};

function PathNavigator({ path }: PathNavigatorProps) {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(path);
  }, [navigate, path]);

  return null;
}

export default PathNavigator;
